
export const CalcValueCellRenderer = ({ value, colDef, data }) => {

  let moneyNf = new Intl.NumberFormat('en-US', { minimumFractionDigits: 6 });

  if (value == null) {
    return <span></span>;
  } else if (!isNaN(value) && data?.code !== 'LINKED11' && data?.code !== 'NDC11' && data?.code !== 'NDC9') {
    value = moneyNf.format(value);
  }

  let entity = '';
  if (data?.calcId != null || data?.calcId1 != null) {
    entity = 'CALC_PROD';
  } else if (data?.ppSrcCode != null) {
    entity = 'CALC_PROD_PP';
  } else if (data?.calcProdId != null || data?.calcProdId1 != null) {
    entity = 'CALC_PROD_RES';
  }

  if (entity === 'CALC_PROD_RES' || entity === 'CALC_PROD' || entity === 'CALC_PROD_PP') {
    let polType = entity === 'CALC_PROD' ? data.polType : '';
    let isLiabCalcProd = entity === 'CALC_PROD' && polType === 'MCDL';
    let isLiabCalcProdRes = entity === 'CALC_PROD_RES' && polType === 'MCDL' && data?.code?.endsWith('_LIAB');
    const isDollar =
      entity === 'CALC_PROD' ||
      entity === 'CALC_PROD_PP' ||
      isLiabCalcProd ||
      isLiabCalcProdRes ||
      (polType !== 'MCDL' && (data?.name?.endsWith(' Amount') || (data?.name ?? '').includes('$')));

    if (isDollar) {
      if (!isNaN(data?.value) && Number(data.value) < 0) {
        value = '-$' + Math.abs(data.value);
      } else {
        value = '$' + value;
      }
    }
  }

  return <span>{value}</span>;
};
